import { Shield } from "shield-js-npm";
import galileo from "./galileo";

// Initialize props to pass the site id and customize the JS url endpoint

const props = {
  siteId: process.env.REACT_APP_DEVICE_SHIELD_SITE_KEY,
};

export const handleShieldEnabled = () => {
  const shield = new Shield();
  return shield.init(props).then(() => {
    return shield
      .getDeviceIntelligence()
      .then((res) => {
        // retrieve session id
        const session_id = res.result.session_id;
        let deviceIntelligence = res.result;

        if (process.env.NODE_ENV !== "production") {
          console.log("sheild--", session_id, process.env.NODE_ENV);
          console.log(deviceIntelligence);
        }

        const resp_obj = {
            "platform": res.result.platform,
            "version": res.result.version,
            "sessionId": res.result.session_id,
            "timestamp": res.result.timestamp,
            "device_intelligence": {
                "device_score": res.result.device_intelligence.device_score,
                "anti_fingerprinting": res.result.device_intelligence.is_anti_fingerprinting,
                "bot": res.result.device_intelligence.is_bot,
                "emulated": res.result.device_intelligence.is_emulated,
                "incognito": res.result.device_intelligence.incognito,
                "proxy": res.result.device_intelligence.proxy,
                "tor": res.result.device_intelligence.is_tor,
                "browserSpoofed": res.result.device_intelligence.is_browser_spoofed,
                "shield_id": res.result.device_intelligence.shield_id
            }
        }
        return resp_obj
      })
      .catch((err) => {
        console.error("Error retrieving device intelligence:", err);
      });
  });
};

export const loadSheild = () => {
  return galileo.fetchIsSheildEnable().then((isEnabled) => {
    return handleShieldStatus(isEnabled);
  });
};

export const handleShieldStatus = (isEnabled) => {
  if (isEnabled) {
    return handleShieldEnabled();
  } else {
    console.warn("Shield is not enabled.");
  }
};
